import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import './styles/DateTimePicker.css';
import './styles/Calendar.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'normalize.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
